<template>
	<div>
		<div class="dashboard-text" v-if="!setShow">OA设置</div>
		<div class="dashboard-content" v-if="!setShow">
			<el-form :inline="true" :model="condition" style="position:relative;padding: 40px 0 0 46px;">
				<div>
					<el-form-item label="审批流名称" class="items">
						<el-input v-model="condition.approval_process_name" placeholder="请输入审批流名称" clearable></el-input>
					</el-form-item>
					<el-form-item label="类型" class="items">
						<el-select v-model="condition.approval_process_type" placeholder="全部" clearable
							style="width: 203px; margin-left: 10px;" filterable>
							<el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态" class="items">
						<el-select v-model="condition.state" placeholder="请选择" style="width:203px;" clearable>
							<el-option v-for="item in roleList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button class="dashboard-button" @click="Find()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button class="dashboard-button" @click="clickBtn('DEL-ALL')">删除</el-button>
					</el-form-item>
					<el-form-item>
						<el-button class="dashboard-buttonWhite" @click="clickBtn('ADD')">新增</el-button>
					</el-form-item>
				</div>
			</el-form>
			<section>
				<el-table ref="multipleTable" height="580" :data="tableData" class="tableBox" style="width: 100%;"
					:header-cell-style="{
						'text-align': 'center',
						background: '#F0F0F0',
						color: '#000'
					}" :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column type="index" label="序号" width="50"></el-table-column>
					<el-table-column label="审批流名称" prop="approval_process_name"></el-table-column>
					<el-table-column label="类型" prop="type_title"></el-table-column>
					<el-table-column label="状态" prop="state">
						<template slot-scope="scope">
							<span v-if="scope.row.state == 1" class="green">启用</span>
							<span v-if="scope.row.state == 0" class="red">停用</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<div class="dashboard-delDisplay">
								<img src="../../../assets/oa/operate-using.png" alt="" v-if="scope.row.state == '0'"
									@click="clickBtn('operateusing', scope.row.id)">
								<img src="../../../assets/oa/operate-deactivate.png" alt="" v-if="scope.row.state == '1'"
									@click="clickBtn('operatedeactivate', scope.row.id)">
								<img src="../../../assets/oa/operate-edit.png" alt="" style="margin: 0 10px;"
									@click="clickBtn('edit', scope.row)">
								<!-- <img src="../../../assets/oa/operate-detail.png" alt=""> -->
							</div>
						</template>
					</el-table-column>
				</el-table>
			</section>
			<section style="text-align:center;padding:20px 0">
				<el-pagination background @current-change="handleCurrentChange" :page-size="condition.page_size"
					layout=" prev, pager, next, jumper" :total="total">
				</el-pagination>
			</section>
		</div>
		<setAddPage ref="add" v-if="setShow" @closeBack="closeBack" :List="List" :num="num"></setAddPage>
	</div>
</template>

<script>
import axios from "axios";
import setAddPage from '../set/setAdd.vue'
export default {
	components: {
		setAddPage
	},
	data() {
		return {
			condition: {
				page_num: 1,
				page_size: 10,
				approval_process_name: '',
				approval_process_type: '',
				state: '',
			},
			List: {
				id: '',
				approval_process_name: '',
				approval_process_type: '',
				remarks: '',
				oaManageSetDetails: [{
					node: 0,
					role_id: "",
					is_leadership: 1,
					ids: null
				}],
				oaManageSetCriterias: [{
					node: 0,
					approval_condition_type: "1",
					approval_criteria: "3",
					judgment_conditions: "",
					ids: null
				}],
				form: {},
			},
			//类型下拉
			typeList: [{
				value: 1,
				label: "加班审批"
			},
			{
				value: 2,
				label: "请假审批"
			},
			{
				value: 3,
				label: "岗位支援审批"
			},
			{
				value: 4,
				label: "离职审批"
			},
			{
				value: 5,
				label: "代岗审批"
			},
			{
				value: 6,
				label: "外出审批"
			},
			{
				value: 7,
				label: "调薪审批"
			},
			{
				value: 8,
				label: "补卡审批"
			},
			{
				value: 9,
				label: "出差审批"
			},
			{
				value: 10,
				label: "处罚审批"
			},
			{
				value: 11,
				label: "入职审批"
			},
			{
				value: 12,
				label: "调岗审批"
			},
			{
				value: 13,
				label: "转正审批"
			},
			{
				value: 14,
				label: "工资明细审批"
			},
			{
				value: 15,
				label: "工资占比审批"
			},
			{
				value: 16,
				label: "工资汇总审批"
			},
			{
				value: 17,
				label: "预算编制审批"
			},
			{
				value: 18,
				label: "预算编制月度审批"
			},
			{
				value: 19,
				label: "保证金审批"
			},
			{
				value: 20,
				label: "冲账审批"
			},
			{
				value: 21,
				label: "转化履约金审批"
			},
			{
				value: 22,
				label: "履约金审批"
			},
			{
				value: 23,
				label: "预算执行"
			}
			],
			total: 0,
			tableData: [],
			selectId: [],
			num: 1,
			roleList: [{
				value: 0,
				label: "停用"
			}, {
				value: 1,
				label: "启用"
			}],
			setShow: false,
		}
	},
	mounted() {

	},
	methods: {
		closeBack() {
			this.Find()
			this.setShow = false
		},
		async Find() {
			var data = await this.$globals.AxiosPost('OaManageSet/getList', this.condition);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.tableData = data.list;
					this.total = data.total;
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		clickBtn(type, item) {
			console.log(item);
			let that = this;
			const TYPE_METHODS = {
				["ADD"]() {
					that.List = {
						id: '',
						approval_process_name: '',
						approval_process_type: '',
						remarks: '',
						oaManageSetDetails: [{
							node: 0,
							role_id: "",
							is_leadership: 1,
							ids: null
						}],
						oaManageSetCriterias: [{
							node: 0,
							approval_condition_type: "1",
							approval_criteria: "3",
							judgment_conditions: "",
							ids: null
						}],
						form: {},
					};
					that.num = 1;
					that.setShow = true;
				},
				["DEL-ALL"]() {
					if (that.selectId.length == 0) {
						that.$message.warning({
							message: "请选择删除的内容"
						});
						return;
					}
					const url = that.$globals.http + "OaManageSet/del";
					axios.post(url, {
						ids: that.selectId,
					}).then((response) => {
						var code = response.data.code;
						var data = response.data.data;
						if (code === '200') {
							that.$message.success(data);
							that.Find();
						} else {
							that.$message.warning(data);
						}
					}).catch((error) => {
						console.log(error)
						that.$message.error("服务器未响应！请稍后重试");
					})


				},
				async ["operateusing"]() {
					//启用
					var data = await that.$globals.AxiosPost('OaManageSet/updateState', {
						id: item,
						state: 1
					});
					if (data === '-2000') {
						that.$message.error('服务器未响应！请稍后重试');
					} else {
						var code = data.code;
						var data = data.data;
						if (code === '200') {
							that.$message.success("启用成功");
							that.Find()
						} else {
							that.$message.warning('请求失败！请稍后重试');
						}
					}
				},
				async ["operatedeactivate"]() {
					//停用
					var data = await that.$globals.AxiosPost('OaManageSet/updateState', {
						id: item,
						state: 0
					});
					if (data === '-2000') {
						that.$message.error('服务器未响应！请稍后重试');
					} else {
						var code = data.code;
						var data = data.data;
						if (code === '200') {
							that.$message.success("停用成功");
							that.Find()
						} else {
							that.$message.warning('请求失败！请稍后重试');
						}
					}
				},
				async ["edit"]() {
					that.List = item;
					that.num = 2;
					that.setShow = true;
					that.$nextTick(() => {
						that.$refs["add"].objestSize = [];
						that.List.oaManageSetDetails.forEach(item => {
							that.$refs["add"].objestSize.push(1)
						})

						that.$refs["add"].objestSize2 = [];
						that.List.oaManageSetCriterias.forEach(item => {
							that.$refs["add"].objestSize2.push(1)
						})
					})
				},
			};
			TYPE_METHODS[type]();
		},
		handleSelectionChange(val) {
			this.selectId = [];
			val.map((item) => {
				this.selectId.push(item.id);
			});
		},
		//分页
		handleCurrentChange(val) {
			this.condition.page_num = val;
			this.Find();
		},
	},
	created() {
		this.Find()
	}
}
</script>

<style>
.items .el-form-item__label {
	font-size: 16px;
}
</style>
<style scoped>
.blue {
	color: #3295FA;
}

.green {
	color: #14BB83;
}

.orange {
	color: #FD892C;
}

.red {
	color: #F05745;
}

.dashboard-text {
	font-size: 20px;
	margin: 40px 0 6px 40px;
	font-weight: 600;
}

.dashboard-content {
	background: #fff;
	margin: 0px 40px;
	font-size: 16px;
}

.dashboard-button {
	width: 85px;
	background: #006E4B;
	color: #FFFFFF;
	border: 1px solid #006E4B;
}

.dashboard-buttonWhite {
	width: 85px;
	color: #006E4B;
	border: 1px solid #006E4B;
}
</style>



// WEBPACK FOOTER //
// set.vue?0e7e628b